(function () {
  "use strict";

  const SELECTORS = {
    section: "[data-product-more-power-section]",
    slider: "[data-product-more-power-slider]",
    dots: "[data-product-more-power-dots]",
  };

  const DOT_CLASSES = {
    active: "size-6 flex items-center justify-center before:size-2 before:rounded-full before:transition-colors before:bg-primary",
    inactive: "size-6 flex items-center justify-center before:size-2 before:rounded-full before:transition-colors before:bg-disabled",
  };

  const MAX_EMBLA_WAIT = 5000;

  const waitForEmbla = () =>
    new Promise((resolve, reject) => {
      const start = Date.now();
      const check = () => {
        if (typeof EmblaCarousel !== "undefined") {
          resolve();
        } else if (Date.now() - start > MAX_EMBLA_WAIT) {
          reject(new Error("EmblaCarousel failed to load within timeout"));
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });

  const createDot = (index, isActive) => {
    const dot = document.createElement("button");
    dot.className = isActive ? DOT_CLASSES.active : DOT_CLASSES.inactive;
    dot.setAttribute("role", "tab");
    dot.setAttribute("aria-selected", String(isActive));
    dot.setAttribute("aria-label", `Slide ${index + 1}`);
    dot.dataset.dotIndex = index;
    return dot;
  };

  const updateDots = (dotsContainer, selectedIndex) => {
    dotsContainer.querySelectorAll("button").forEach((dot, i) => {
      const isActive = i === selectedIndex;
      dot.setAttribute(
        "class",
        isActive ? DOT_CLASSES.active : DOT_CLASSES.inactive,
      );
      dot.setAttribute("aria-selected", String(isActive));
    });
  };

  const renderDots = (embla, dotsContainer) => {
    const scrollSnaps = embla.scrollSnapList();
    dotsContainer.replaceChildren();

    scrollSnaps.forEach((_, index) => {
      const dot = createDot(index, index === embla.selectedScrollSnap());
      dot.addEventListener("click", () => embla.scrollTo(index));
      dotsContainer.appendChild(dot);
    });
  };

  const createCarousel = async (section) => {
    const sliderNode = section.querySelector(SELECTORS.slider);
    const dotsContainer = section.querySelector(SELECTORS.dots);

    if (!sliderNode) return null;

    try {
      await waitForEmbla();
    } catch {
      return null;
    }

    const embla = EmblaCarousel(sliderNode, {
      loop: false,
      align: "start",
      skipSnaps: false,
      containScroll: "trimSnaps",
    });

    if (dotsContainer) {
      renderDots(embla, dotsContainer);

      embla.on("select", () =>
        updateDots(dotsContainer, embla.selectedScrollSnap()),
      );

      embla.on("reInit", () => renderDots(embla, dotsContainer));
    }

    return embla;
  };

  const initializeSection = (section) => {
    let embla = null;
    const mql = window.matchMedia("(max-width: 1023px)");

    const handleChange = async (e) => {
      if (e.matches && !embla) {
        embla = await createCarousel(section);
      } else if (!e.matches && embla) {
        embla.destroy();
        embla = null;
        const dotsContainer = section.querySelector(SELECTORS.dots);
        if (dotsContainer) dotsContainer.replaceChildren();
      }
    };

    mql.addEventListener("change", handleChange);
    handleChange(mql);
  };

  const init = () => {
    document
      .querySelectorAll(SELECTORS.section)
      .forEach((section) => initializeSection(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
 